import { render, staticRenderFns } from "./GetBiometria.vue?vue&type=template&id=b68d567e"
import script from "./GetBiometria.vue?vue&type=script&lang=js"
export * from "./GetBiometria.vue?vue&type=script&lang=js"
import style0 from "./GetBiometria.vue?vue&type=style&index=0&id=b68d567e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports